import { useCallback } from "react";

import { usePromise } from "@touchtech/web-hooks";

import { api, createStoresSearchUrl } from "@is/services";
import { Store } from "@is/types";

type SearchStoresParams = {
  page: number;
  pageSize: number;
  searchTerm?: string;
  country?: string;
  sortBy?: string;
};

type SearchStoresResult = {
  items: Store[];
  totalCount: number;
};

type SearchStoresState = {
  isPending: boolean;
  error: Error | null;
  data: SearchStoresResult | null;
};

async function handleSearchStores(
  params: SearchStoresParams
): Promise<SearchStoresResult> {
  const data = (await api.post(
    createStoresSearchUrl(),
    params
  )) as SearchStoresResult;

  return data;
}

export const useSearchStores = (): [
  SearchStoresState,
  (params: SearchStoresParams) => Promise<SearchStoresResult>
] => {
  const [{ isPending, error, data }, dispatch] =
    usePromise<SearchStoresResult>();

  const searchStores = useCallback(
    (params: SearchStoresParams) => dispatch(handleSearchStores(params)),
    [dispatch]
  );

  return [{ isPending, error, data }, searchStores];
};
